/**
 * Deadline-rule-related strings.
 *
 * Help text (h_) is seeded from the deadlineRule schema field comments
 * (server/src/schemas/deadlineRule.ts) — verify against the implementation.
 */
export default {
    d_ruleReference: 'Rule Reference',
    h_ruleReference: 'The court rule this deadline comes from (e.g. FRCP 12(a)(1)). For your reference — it does not affect the calculation.',

    d_triggerType: 'Trigger Type',
    h_triggerType: 'What starts the clock for this deadline: Case Created (a new case of this type), Stage Entered (the case reaches a specific stage), Custom Date (a date you enter on the case), or Rule Completed (another deadline is completed — used to chain deadlines).',

    d_triggerDateLabel: 'Date Label',
    h_triggerDateLabel: 'The label shown for the custom date field on the case (e.g. "Service Date"). Only used when the trigger is a Custom Date.',

    d_triggerRuleId: 'Trigger Rule',
    h_triggerRuleId: 'The deadline rule that must be completed before this one starts. Only used when the trigger is Rule Completed (chaining deadlines).',

    d_offsetAmount: 'Offset (days)',
    h_offsetAmount: 'How many days from the trigger the deadline falls. A positive number counts forward (after the trigger); a negative number counts backward (before it).',

    d_offsetUnit: 'Day Type',
    h_offsetUnit: 'Whether the offset is counted in calendar days (every day) or business days (skipping weekends and holidays).',

    d_rolloverDirection: 'Weekend/Holiday Rollover',
    h_rolloverDirection: 'If the calculated date lands on a weekend or holiday, how to adjust it: Forward to the next business day, Backward to the previous business day, or roll to a specific weekday.',

    d_rolloverWeekday: 'Target Weekday',
    h_rolloverWeekday: 'The weekday to roll to (e.g. Monday) when the rollover is set to a specific weekday.',

    d_inclusiveStart: 'Date Counting',
    h_inclusiveStart: 'If on, the trigger date counts as day 1 of the offset. If off, counting starts the day after the trigger.',

    d_serviceExtensionDays: 'Extension Days',
    h_serviceExtensionDays: 'Extra days added for the method of service (e.g. +5 days for service by mail). Leave blank for none.',

    d_serviceExtensionUnit: 'Extension Day Type',
    h_serviceExtensionUnit: 'Whether the service extension is counted in calendar or business days.',

    d_isCommon: 'Common Rule',
    h_isCommon: 'If on, this rule applies to every court, not just the courts it is explicitly assigned to.',

    d_autoFire: 'Auto-fire',
    h_autoFire: 'If on, the deadline is created automatically when the trigger occurs. If off, you create it manually.',
};
